import { render } from "./GangDetails.vue?vue&type=template&id=ddff3d2e"
import script from "./GangDetails.vue?vue&type=script&lang=js"
export * from "./GangDetails.vue?vue&type=script&lang=js"

import "./GangDetails.vue?vue&type=style&index=0&id=ddff3d2e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__